module.exports = __webpack_public_path__ + "static/media/food_false_active.a337bf38.jpg";